import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { OpenBalanceTexts } from "../utils/openBalance-enums";
export const OrderNotFound = () => {
    return (_jsxs(Box, { children: [_jsx(Typography, Object.assign({ variant: "h2", gutterBottom: true, color: "error" }, { children: OpenBalanceTexts.ORDER_NOT_FOUND_TITLE })), _jsxs(Typography, { children: [OpenBalanceTexts.ORDER_NOT_FOUND_MESSAGE, " "] })] }));
};
